import * as I from "immutable";

const DestinationType = I.Record({
  house: "h",
  meeting: "m",
  lunch: "l",
  other: "o",
  pickupTrainee: "pt",
  dropoffTrainee: "dt",
});

const ServiceType = I.Record({
  maintenance: "MAI",
  store: "STR",
});

export const DATE_FORMAT_DESKTOP = "ddd, MMM D, YYYY";
export const DATE_FORMAT_ISO = "YYYY-MM-DD";
export const DATE_FORMAT_MOBILE = "ddd, MMM D";

export const DEFAULT_MANPOWER = 1.0;

export const DESTINATION_TYPE = new DestinationType();

export const LUNCH_TITLE = "Lunch";

// Max number of waypoints per request. Includes origin & destination.
export const MAX_NUMBER_OF_WAYPOINTS = 10;

export const MIN_SEARCH_LENGTH = 2;

export const ROUTE_UNASSIGNED_LABEL = "Unassigned";

export const SERVICE_TYPE = new ServiceType();

export const TIME_FORMAT = "h:mm A";

export const SATURDAY_TAGS_REASON = [
  "Rescheduled: House inaccessible",
  "Rescheduled: Gardener unavailable",
  "Rescheduled: Other",
  "First visit: Ergeon initiated",
  "First visit: Customer initiated",
  "Project",
];

export const SATURDAY_TAGS_CATEGORY = [
  "Debris",
  "Cleanup",
  "Project",
  "FS Visit",
  "FS Team Shopping",
  "Van Maintenance",
];

export default {
  DATE_FORMAT_DESKTOP,
  DATE_FORMAT_ISO,
  DATE_FORMAT_MOBILE,
  DEFAULT_MANPOWER,
  DESTINATION_TYPE,
  LUNCH_TITLE,
  MAX_NUMBER_OF_WAYPOINTS,
  MIN_SEARCH_LENGTH,
  ROUTE_UNASSIGNED_LABEL,
  SERVICE_TYPE,
  TIME_FORMAT,
};



/** WEBPACK FOOTER **
 ** ./src/app/config/constants.js
 **/